import { REGEX } from '@constants'

/**
 * Validate email address
 * @param {string} email - The email to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidEmail = email => {
	if (!email || typeof email !== 'string') return false
	return REGEX.EMAIL.test(email.trim())
}

/**
 * Alias for isValidEmail (for consistency with naming conventions)
 * @param {string} email - The email to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const validateEmail = isValidEmail

/**
 * Validate phone number
 * @param {string} phone - The phone number to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidPhone = phone => {
	if (!phone || typeof phone !== 'string') return false
	return REGEX.PHONE.test(phone.trim())
}

/**
 * Validate URL
 * @param {string} url - The URL to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidUrl = url => {
	if (!url || typeof url !== 'string') return false
	return REGEX.URL.test(url.trim())
}

/**
 * Validate required field
 * @param {*} value - The value to check
 * @returns {boolean} True if not empty, false otherwise
 */
export const isRequired = value => {
	if (value === null || value === undefined) return false
	if (typeof value === 'string') return value.trim().length > 0
	if (Array.isArray(value)) return value.length > 0
	if (typeof value === 'object') return Object.keys(value).length > 0
	return true
}

/**
 * Validate minimum length
 * @param {string|Array} value - The value to check
 * @param {number} min - Minimum length
 * @returns {boolean} True if meets minimum, false otherwise
 */
export const minLength = (value, min) => {
	if (!value) return false
	return value.length >= min
}

/**
 * Validate maximum length
 * @param {string|Array} value - The value to check
 * @param {number} max - Maximum length
 * @returns {boolean} True if within maximum, false otherwise
 */
export const maxLength = (value, max) => {
	if (!value) return true
	return value.length <= max
}

/**
 * Validate number range
 * @param {number} value - The number to check
 * @param {number} min - Minimum value
 * @param {number} max - Maximum value
 * @returns {boolean} True if within range, false otherwise
 */
export const isInRange = (value, min, max) => {
	const num = Number(value)
	return !isNaN(num) && num >= min && num <= max
}
